import { Injectable } from '@angular/core';
import { InjectQueryParam } from '@ddt-web/generic-utils';
import { SharedQueryParamKey } from '@ddt-web/url';


/**
 * This config service is mainly used to identify the locale based on url otherwise it will return the default one
 * For localHost we will be relying on locale parameter , example - http://localhost:4218/?fee=3&locale=au
 */
@Injectable({
	providedIn: 'root'
})
export class LocaleUtilResolverService {
	private readonly defaultLocale: string = 'us';
	@InjectQueryParam(SharedQueryParamKey.LOCALE) private readonly locale: string;

	/** 
	 * Gets the locale from metadata property set by cwp 
	 * examples - en_US, en_GB, please refer locale_country.enum.ts file for all values
	 * provides country -> locale
	 * en_US -> us
	 * en_GB -> gb
	 * 
	* @returns locale string to be appended in config
	*/
	public getResolvedLocaleValue(): string {
		const metaLocale = document.querySelector('meta[property="og:locale"]');
		const localeSyntax = metaLocale?.getAttribute('content')?.toLowerCase();
		return this.locale || localeSyntax?.split('_')?.[1] || this.defaultLocale;
	}
}
